// removed by extract-text-webpack-plugin
module.exports = {"btn":"-faXAraXEC5g5Jwgv0Gb7","logo":"_1Fnz1SLv8_BakPZAxbq7_u","container":"_2x7QW6r99LU7NE5x3R6FCz","landingText":"_1IvRP9aETwuchv0u_RKi5D"};


//////////////////
// WEBPACK FOOTER
// ./src/App/components/SecuritySatModal/styles.css
// module id = 3253
// module chunks = 0